document.addEventListener('DOMContentLoaded', () => {
  const heEventsFilterElement = document.getElementById('he-events-filter-btn');

  if (heEventsFilterElement) {
    new HeEvents();
  }
});

export class HeEvents {}
